module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/mobile-multi-sample-bg-ff44d77b7ff27448a20e53d33c7776cb.jpg";